import { VendorCreatePage } from '@/features/vendor/pages/VendorCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/vendor/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["vendor.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VendorCreatePage,
})
